<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('changed', 0)"
          :disabled="prev_dsbl"
          class="mr-1 btn-page prev"
          color="primary"
        >
          <v-icon small>mdi-chevron-left-circle</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.utils.paginator.prev }}</span>
    </v-tooltip>
    <slot></slot>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          icon
          small
          @click.stop="$emit('changed', 1)"
          :disabled="next_dsbl"
          class="ml-1 btn-page next"
          color="primary"
        >
          <v-icon small>mdi-chevron-right-circle</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.utils.paginator.next }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  props: {
    prev_dsbl: {
      type: Boolean,
      default: false
    },
    next_dsbl: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<!--
<style lang="scss">
.btn-page {
  &.prev {
  }
  &.next {
  }
}
</style> !-->
